import { reduce, isPlainObject, isArray, camelCase, snakeCase } from 'lodash';

const changeCase = (caseType, obj) => {
    if (typeof obj === 'string') {
        return caseType(obj);
    }

    if (isArray(obj) && obj.length === 0) { return obj; }

    return reduce(obj, (result, value, key) => {
        if (isArray(obj)) {
            return obj.map((o) => isPlainObject(o) || isArray(o) ? changeCase(caseType, o) : o);
        }

        const finalValue = isPlainObject(value) || isArray(value) ? changeCase(caseType, value) : value;
        return { ...result, [caseType(key)]: finalValue };
    }, {});
};

export const toSnakeCase = (obj) => changeCase(snakeCase, obj);

export const toCamelCase = (obj) => changeCase(camelCase, obj);
